function initScrollAnimations() {
  const animatedElements = document.querySelectorAll('.animated');
  
  if (animatedElements.length === 0) return;
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = getDelayFromClass(entry.target);
        setTimeout(() => {
          entry.target.classList.add('show');
        }, delay);
      } else {
        entry.target.classList.remove('show');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -100px 0px'
  });
  
  animatedElements.forEach(element => {
    observer.observe(element);
  });
}

function getDelayFromClass(element) {
  const classList = element.classList;
  for (let className of classList) {
    if (className.startsWith('delay-')) {
      const delayValue = className.replace('delay-', '');
      return parseInt(delayValue) || 0;
    }
  }
  return 0;
}

//document.addEventListener('DOMContentLoaded', initScrollAnimations);
window.addEventListener('load', initScrollAnimations);
